export default "__VITE_ASSET__24afaba9__"